import React from "react";
import ProjectItem from "./ProjectItem";

const Projects = ({ info }) => {
  return (
    <>
      {info.map((item, key) => (
        <ProjectItem item={item} key={key} />
      ))}
    </>
  );
};

export default Projects;